export default {"src":"/_next/static/media/section-6-bg-2.70934059.svg","height":164,"width":187,"blurWidth":0,"blurHeight":0};